/* eslint-disable */
export default {
  unknown: '알 수 없음',
  anonymous: '익명',
  activeCalls: '모든 통화',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCalls"@#@ @source: @#@"All Calls"@#@
